import { useEffect, useState } from "react";
import {  TextField } from "@material-ui/core";
import OrderService from "../../services/PosService/OrderService";
import withLoader from "../../components/layouts/WithLoader";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import makeAnimated from "react-select/animated";
import CashRegisterService from "../../services/ProductSellBToC/CashRegisterService";
import { Link } from "react-router-dom";
import Select from "react-select";
import B2CKpiProducts from "./Table/B2CKpiProducts";

const KPIProduitsB2C = ({ startLoading, stopLoading }) => {

  const [dateBegin, setDateBegin] = useState("any");
  const [dateEnd, setDateEnd] = useState("any");
  const [etatMagasin, setEtatMagasin] = useState([]);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const animatedComponents = makeAnimated();
  const [magasinSelectedOption, setMagasinSelectedOption] = useState(null);
  const [magasinId, setMagasinId] = useState(0);
  const [selectedOption, setSelectedOption] = useState(null);
    const [ca, setCa] = useState(0);

  const [nbrTicket, setNbrTicket] = useState(0);
  const [pm, setPm] = useState(0);
  const [pn, setPn] = useState(0);
  const [iv, setIv] = useState(0);


  const [allMagasin, setAllMagasin] = useState([]);
  const [magasinSelectPlaceHolder, setMagasinSelectPlaceHolder] =
    useState("");

  const onChangeSelectedMagasin = (selectedOptionn) => {
    setSelectedOption();
    setMagasinId(selectedOptionn.value);
    setMagasinSelectedOption(selectedOptionn.label);
    setMagasinSelectPlaceHolder(selectedOptionn.label)
  };
  const onChangeDateBegin = (event) => {
    const selectedValue = event.target.value;

    const updatedValue = selectedValue.includes("T")
      ? selectedValue.split(":").slice(0, 2).join(":") + ":00" // Set seconds to 00 if it's a datetime-local input
      : selectedValue + "T00:00:00"; // For date input, append "T00:00:00" to set the first second of the day

    setDateBegin(updatedValue);
  };


  const onChangeDateEnd = (event) => {
    const selectedValue = event.target.value;

    // Check if the selected value includes a time part
    const updatedValue = selectedValue.includes("T")
      ? selectedValue.split(":").slice(0, 2).join(":") + ":59" // If time exists, append ":59" to set seconds to 59
      : selectedValue + "T23:59:59"; // If it's a date-only input, append "T23:59:59" for the last second of the day

    setDateEnd(updatedValue);
  };
  const onGetFacturesByFiltersHandler = () => {
    startLoading();
    OrderService.getTicketsKPI( magasinId, dateBegin, dateEnd)
      .then((response) => {
        setEtatMagasin(response.data.prNbr);
        setCa(response.data.chiffreAffaires);
        setNbrTicket(response.data.nombreTicket);
        setPm(response.data.pm);
        setPn(response.data.pn);
        setIv(response.data.iv)
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : facture last month not deleted");
      })
      .finally(() => {
        stopLoading();
      });
  };
  useEffect(() => {
    CashRegisterService.getAllShop(getCurrentUserId())
      .then((response) => {
        if (response.data.success) {
          setAllMagasin([]);
          response.data.success.map((element) => {
            setAllMagasin((oldArray) => [
              ...oldArray,
              { value: element.id, label: element.ref + "-" + element.name },
            ]);
          })
          // setAvailableShop(response.data.success);

        } else {
          console.log("error in getAllShop", response.data.success);
        }
      })
      .catch((e) => {
        console.log("error in getAllShop", e);
      });

  }, []);


  const cardStatistique = () => {
    return (
      <>
        <section class="content">
          <div className="container-fluid">
            <div className="row">
              {ca !== null && (
                <div className="col-sm-6 col-12">
                  <div className="info-box bg-gray-dark">
                    <span className="info-box-icon">
                      <i class="fas fa-sack-dollar"></i>
                    </span>
                    <div className="info-box-content">
                      <span className="info-box-text">Chiffre d'affaires</span>
                      <span className="info-box-number">{ca}</span>
                      <div className="progress">
                        <div
                          className="progress-bar"
                          style={{ width: "100%" }}
                        />
                      </div>
                      <span className="progress-description"></span>
                    </div>
                  </div>
                </div>
              )}
              {nbrTicket !== null && (
                <div className="col-sm-6 col-12">
                  <div className="info-box bg-gray-dark">
                    <span className="info-box-icon">
                      <i class="fas fa-hand-holding-dollar"></i>{" "}
                    </span>
                    <div className="info-box-content">
                      <span className="info-box-text">Nombre des tickets</span>{" "}
                      <span className="info-box-number">{nbrTicket}</span>
                      <div className="progress">
                        <div
                          className="progress-bar"
                          style={{ width: "100%" }}
                        />
                      </div>
                      <span className="progress-description">
                        {/* 70% Increase in 30 Days */}
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </section>
      </>
    );
  };
  const cardStatistiqueNotPayed = () => {
    return (
      <>
        <section class="content">
          <div className="container-fluid">
            <div className="row">
              {pm !== null && (
                <div className="col-sm-4 col-12">
                  <div className="info-box bg-gray-dark">
                    <span className="info-box-icon">
                      <i class="fas fa-sack-dollar"></i>
                    </span>
                    <div className="info-box-content">
                      <span className="info-box-text">Panier Moyen</span>
                      <span className="info-box-number">{pm.toFixed(3)} DNT</span>
                      <div className="progress">
                        <div
                          className="progress-bar"
                          style={{ width: "100%" }}
                        />
                      </div>
                      <span className="progress-description"></span>
                    </div>
                  </div>
                </div>
              )}
              {pn !== null && (
                <div className="col-sm-4 col-12">
                  <div className="info-box bg-gray-dark">
                    <span className="info-box-icon">
                      <i class="fas fa-hand-holding-dollar"></i>{" "}
                    </span>
                    <div className="info-box-content">
                      <span className="info-box-text">Nombre total des produits </span>{" "}
                      <span className="info-box-number">{pn}</span>
                      <div className="progress">
                        <div
                          className="progress-bar"
                          style={{ width: "100%" }}
                        />
                      </div>
                      <span className="progress-description">
                        {/* 70% Increase in 30 Days */}
                      </span>
                    </div>
                  </div>
                </div>
              )}
              {iv !== null && (
                <div className="col-sm-4 col-12">
                  <div className="info-box bg-gray-dark">
                    <span className="info-box-icon">
                      <i class="fas fa-hand-holding-dollar"></i>{" "}
                    </span>
                    <div className="info-box-content">
                      <span className="info-box-text">Indice de vente </span>{" "}
                      <span className="info-box-number">{iv.toFixed(3)}</span>
                      <div className="progress">
                        <div
                          className="progress-bar"
                          style={{ width: "100%" }}
                        />
                      </div>
                      <span className="progress-description">
                        {/* 70% Increase in 30 Days */}
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </section>
      </>
    );
  };

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6"></div>
            <div className="col-md-6">
              <ol class="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <Link to="/" style={{ color: "black" }}>
                    Home
                  </Link>
                </li>

                <li
                  className="breadcrumb-item active"
                  style={{ color: "black" }}
                >
                  Vente
                </li>
                <li
                  className="breadcrumb-item active"
                  style={{ color: "black" }}
                >
                  Vente B2C
                </li>
                <li
                  className="breadcrumb-item active"
                  style={{ color: "black" }}
                >
                  Etat de Magasin
                </li>
              </ol>
            </div>
          </div>
        </div>
      </section>


      <section className="content ">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <div class="card card-dark">
                <div class="card-body">
                  <div class="row">
                    <div className="col-sm-4">
                      <div className="form-group">
                        <label htmlFor="inputClientCompany">
                          Choisir le magasin
                        </label>
                        <Select
                          closeMenuOnSelect={true}
                          components={animatedComponents}
                          defaultValue={magasinSelectedOption}
                          onChange={onChangeSelectedMagasin}
                          options={allMagasin}
                          placeholder={magasinSelectPlaceHolder}
                        />
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <div className="form-group">
                        <label htmlFor="inputName">Date début</label>

                        <TextField
                          style={{ width: "100%" }}
                          className="col-sm-12"
                          variant="outlined"
                          // value={dateBegin}
                          onChange={onChangeDateBegin}
                          id="datetime-local"
                          type="date"
                          defaultValue="date"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          size="small"
                        />
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <div className="form-group">
                        <label htmlFor="inputName">Date fin</label>

                        <TextField
                          style={{ width: "100%" }}
                          className="col-sm-12"
                          variant="outlined"
                          // value={dateEnd}
                          onChange={onChangeDateEnd}
                          id="datetime-local"
                          type="date"
                          defaultValue="date"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          size="small"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-footer">
                  <div className="col-sm-12  text-center">
                    <button
                      className="btn btn-dark"
                      onClick={onGetFacturesByFiltersHandler}
                    >
                      Valider le choix
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {cardStatistique()}
      {cardStatistiqueNotPayed()}

      {etatMagasin && Array.isArray(etatMagasin) && (
        <section className="content ">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-12">
                <B2CKpiProducts listEtat={etatMagasin} />
              </div>
            </div>
          </div>
        </section>
      )}

    </div>
  );
};
export default withLoader(KPIProduitsB2C);
